<template>
    <component :is="tag" style="height: 100%">
        <slot
            :products="wizardProducts"
            :campaign="campaign"
            :is-loading="isLoading"
            :products-page="productsPage"
            :products-per-page="productsPerPage"
            :get-next-products-page="getNextProductsPage"
            :get-previous-products-page="getPreviousProductsPage"
        />
    </component>
</template>
<script>
    import BaseProposalStepMixin from "../mixins/BaseProposalStepMixin";

    export default {
        name: 'ProductsWizardProvider',
        mixins: [
            BaseProposalStepMixin,
        ],
        data() {
          return {
              isLoading: false,
              productsPerPage: 24,
          }
        },
        watch: {
            $route() {
                this.loadProducts();
            }
        },
        created() {
            this.isLoading = true;
            this.loadProducts()
                .catch((error) => {
                    this.handleHttpError(error)
                })
                .then(() => {
                    this.isLoading = false;
                })
        }
    }
</script>
